import PropTypes from 'prop-types';

function ReadyOrNull(props) {
  const {
    children = null,
    ready,
  } = props;

  if (!ready) return null;

  return children;
}

ReadyOrNull.propTypes = {
  children: PropTypes.node,
  ready: PropTypes.bool.isRequired,
};

export default ReadyOrNull;
